module.exports = __webpack_public_path__ + "img/1.369a6b45.png";